<template lang="html">
  <div class="edit-site-logo tier tier-three">
    <Tooltip
      content="Your brand logo will appear in the header and footer of your website"
    />

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="tier-content">
      <Tabs :headings="['Your Logo', 'Logo Design']">
        <Tab>
          <div>
            <FileUploadForm
              label="Site Logo"
              helpText="File types accepted: <strong>JPG, PNG</strong>"
              paramResource="site"
              paramName="logo"
              :showUnsplash="false"
              :images="images"
              :errors="errors"
              :stringUpdateFunction="stringUpdateFunction"
              :fileUpdateFunction="fileUpdateFunction"
            />

            <Btn v-if="images.length" secondary class="btn-remove" @click="deleteLogo">
              Delete Logo
            </Btn>

            <hr />

            <SiteLogoForm @submit="submitSite" v-model="site" />
          </div>
        </Tab>

        <Tab>
          <div>
            <div class="helper-text">
              <p>
                Thank you for using the beta version of our platform. We're
                currently implementing the requested feature. If you'd like to
                be notifed on updates and releases, please sign up to our
                newsletter and follow our social channels.
              </p>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'
import {mapGetters} from 'vuex'

import {
  updateCompanySiteData,
  updateCompanySiteLogoImage,
  deleteCompanySiteLogoImage,
  readCompanySiteData
} from '@/lib/sites'

import SiteLogoForm from '@/components/forms/SiteLogoForm'
import Tooltip from '@/components/Tooltip'
import Tabs from '@/components/Tabs'
import Btn from '@/components/Btn'
import Tab from '@/components/Tab'
import FileUploadForm from '@/components/forms/FileUploadForm'

export default {
  name: 'EditSiteLogo',

  components: {
    SiteLogoForm,
    Tooltip,
    Tabs,
    Btn,
    Tab,
    FileUploadForm
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {}
    }
  },

  computed: {
    ...mapGetters(['sessionToken']),

    title() {
      return `Editing ${this.site.name} Logo`
    },

    images() {
      return this.site.logo_versions
    },

    stringUpdateFunction() {
      const companyId = this.companyId
      const siteId = this.siteId

      return (logo) => {
        return updateCompanySiteData(companyId, siteId, logo)
          .then(({data}) => {
            // computed is currying callback function to be used by upload form
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.site = data
            this.$emit('updatePage')
            this.triggerNotification('success', 'logo', 'updated')

            return data
          })
          .catch(({response}) => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.errors = response.errors
          })
      }
    },

    fileUpdateFunction() {
      const companyId = this.companyId
      const siteId = this.siteId
      const token = this.sessionToken

      return (logo) => {
        return updateCompanySiteLogoImage(companyId, siteId, logo, token)
          .then(({data}) => {
            // computed is currying callback function to be used by upload form
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.site = data
            this.$emit('updatePage')
            this.triggerNotification('success', 'logo', 'updated')

            return data
          })
          .catch(({response}) => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.errors = response.errors
          })
      }
    }
  },

  methods: {
    submitSite() {
      updateCompanySiteData(this.companyId, this.siteId, this.site)
        .then(({data}) => {
          this.$emit('updatePage')
          this.triggerNotification('success', 'logo settings', 'updated')
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    deleteLogo() {
      deleteCompanySiteLogoImage(this.companyId, this.siteId).then(() => {
        this.site.logo_versions = []
        this.$emit('updatePage')
        this.triggerNotification('success', 'logo', 'deleted')
      })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
